import {kmApiLink} from "@pg-mono/km-routes";

import {kmApi} from "@/features/km_app/api/km_api";

import {HomeMatchSurveyDto} from "../types/home_match_preferences";
import {isHomeMatchSurveyDataEmpty} from "../utils/is_home_match_survey_data_empty";

export const getHomeMatchPreferencesApi = kmApi.injectEndpoints({
    endpoints: (builder) => ({
        getHomeMatchPreferences: builder.query<HomeMatchSurveyDto | null, void>({
            query: () => ({
                url: kmApiLink.survey(),
                method: "GET"
            }),
            transformResponse: (response: HomeMatchSurveyDto): HomeMatchSurveyDto | null => {
                if (isHomeMatchSurveyDataEmpty(response)) {
                    return null;
                }

                return response;
            },
            providesTags: ["HomeMatchPreferences"]
        })
    })
});

export const {useGetHomeMatchPreferencesQuery} = getHomeMatchPreferencesApi;
import {kmApiLink} from "@pg-mono/km-routes";

import {kmApi} from "@/features/km_app/api/km_api";

import {HomeMatchSurveyDto} from "../types/home_match_preferences";
import {isHomeMatchSurveyDataEmpty} from "../utils/is_home_match_survey_data_empty";

export const getHomeMatchPreferencesApi = kmApi.injectEndpoints({
    endpoints: (builder) => ({
        getHomeMatchPreferences: builder.query<HomeMatchSurveyDto | null, void>({
            query: () => ({
                url: kmApiLink.survey(),
                method: "GET"
            }),
            transformResponse: (response: HomeMatchSurveyDto): HomeMatchSurveyDto | null => {
                if (isHomeMatchSurveyDataEmpty(response)) {
                    return null;
                }

                return response;
            },
            providesTags: ["HomeMatchPreferences"]
        })
    })
});

export const {useGetHomeMatchPreferencesQuery} = getHomeMatchPreferencesApi;
